import { render, staticRenderFns } from "./FundDestinations.vue?vue&type=template&id=b061fd64&scoped=true"
import script from "./FundDestinations.vue?vue&type=script&lang=js"
export * from "./FundDestinations.vue?vue&type=script&lang=js"
import style0 from "./FundDestinations.vue?vue&type=style&index=0&id=b061fd64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b061fd64",
  null
  
)

export default component.exports